import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import BasicBtn from "./../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import FaqApi from "../../../api/faq.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";

const OperationFaqCreate = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [faqContent, setFaqContent] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const createFaqFunc = async () => {
    try {
      if (title === "") {
        return toast("질문을 입력해주세요.");
      }

      if (faqContent === "") {
        return toast("내용을 입력해주세요.");
      }

      const data = {
        question: title,
        content: faqContent,
      };

      await FaqApi.createFaq(data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>자주 묻는 질문 편집 및 추가</TableTitle>
          <FaqInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <FaqInputTitle>질문</FaqInputTitle>
            <MainInput
              type={"text"}
              placeholder={"알림 제목을 입력해 주세요."}
              style={{ width: "572px" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </FaqInputWrapper>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={faqContent}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setFaqContent(e);
            }}
            editorHeight={668}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <BasicBtn
              onClick={() => {
                createFaqFunc();
              }}
            >
              저장하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationFaqCreate;

const FaqInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  margin-bottom: 24px;
`;

const FaqInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
